import { onlineManager } from "@tanstack/react-query"
import { useSyncExternalStore } from "react"
import { OfflineBanner } from "@/design-system/index.ts"

/*
 * Beacon without a network. The service worker still opens the app's shell, but nothing a Member
 * reads is kept on the device, so there is nothing to show until the network is back. The query
 * cache holds its questions meanwhile (TanStack Query pauses a query while the browser is offline)
 * and asks them as soon as it returns, so both states clear by themselves:
 *
 * - opened offline, the shell can't learn who is signed in, and says "You're offline" on the canvas
 *   in place of its frame (`Layout`, through `ShellError`, when `offline.ts` says it is waiting),
 *   with Try again for a browser wrong about it (`assumeOnline`);
 * - gone offline once open, a slim banner sits atop the page (`OfflineBanner`), which keeps what it
 *   already shows.
 */

/** Whether the browser is online, as the query cache sees it. */
export function useOnline() {
  return useSyncExternalStore(onlineManager.subscribe.bind(onlineManager), () =>
    onlineManager.isOnline(),
  )
}

/** The banner atop the page while the network is gone, and nothing once it is back. */
export function ConnectionBanner() {
  return useOnline() ? null : <OfflineBanner />
}
